<template>
  <div class="login">
    <div class="common-cover" v-if="isShow" @click="isShow=!isShow"></div>
    <div class="login_con_top reg_con_top"></div>
    <!-- <div class="reg_nav"> -->
      <!-- <a href="{:url('/login/registergr')}" class="reg_nav_l on">个人注册</a>
      <a href="{:url('/login/registerqy')}" class="reg_nav_r">企业注册</a> -->
    <!-- </div> -->
    <div class="reg_con clearfix" v-loading="qyloading">
      <div class="m-login-panel">
        <div style="text-align: right;margin: 15px auto -10px;" class="back_index">
          <router-link :to="{path:'/'}">返回首页&gt;</router-link>
        </div>
        <el-form ref="dataForm" :rules="rules" :model="formData">
          <div style="margin: auto;">
            <div class="reg_con_pub clearfix">
              <i>*</i>
              <div class="login_con_pub">
                <div class="login_con_pub_info login_con_pub_name">
                  <el-form-item prop='account' class="demo">
                    <el-input v-model="formData.account" placeholder="请输入账号"></el-input>
                  </el-form-item>
                </div>
              </div>
            </div>
            <div class="reg_con_pub clearfix">
              <i>*</i>
              <div class="login_con_pub">
                <div class="login_con_pub_info login_con_pub_phone">
                  <el-form-item prop='tel'>
                    <el-input v-model="formData.tel" placeholder="请输入手机号码"></el-input>
                  </el-form-item>
                </div>
              </div>
            </div>
            <div class="reg_con_pub clearfix">
              <i>*</i>
              <div class="login_con_pub">
                <div class="login_con_pub_info login_con_pub_phone clearfix">
                  <el-form-item prop='telCode'>
                    <el-input v-model="formData.telCode" placeholder="手机验证码" maxlength="11"></el-input>
                  </el-form-item>
                  <a href="javascript:;" v-show="codeType" @click="sendCode">发送手机验证码</a>
                  <a href="javascript:;" v-show="!codeType" >{{ count }}s</a>
                </div>
              </div>
            </div>
            <div class="reg_con_pub clearfix">
              <i>*</i>
              <div class="login_con_pub">
                <div class="login_con_pub_info login_con_pub_pass">
                  <el-form-item prop='password'>
                    <el-input type="password" v-model="formData.password" placeholder="输入密码" @blur="pwStrength(formData.password)"></el-input>
                  </el-form-item>
                </div>
              </div>
            </div>
            <div class="reg_con_pub clearfix">
              <i>*</i>
              <div class="login_con_pub">
                <div class="login_con_pub_info login_con_pub_yzm">
                  <el-form-item prop='confirmpassword'>
                    <el-input type="password" v-model="formData.confirmpassword" placeholder="确认密码"></el-input>
                  </el-form-item>
                </div>
              </div>
            </div>
            <div class="reg_con_pub clearfix">
              <div class="if_have">如有账号请<router-link :to="{path:'/Login'}">登录</router-link></div>
            </div>
          </div>
        </el-form>
        <div class="regist_xieyibtn">
          <el-checkbox v-model="checked"></el-checkbox> 了解并同意<em @click="isShow = !isShow">《志鹏供应链用户注册协议》</em>
        </div>
        <div class="reg_xieyi-con" v-if="isShow">
          <div class="reg_xieyi-con-title">
            <b>志鹏供应链用户注册协议</b>
            <a href="javascript:;"  @click="isShow=!isShow">X</a>
          </div>
          <div style="height:35px;"></div>
          <div class="reg_xieyi-con-bototom" v-html="about"></div>
          <a href="javascript:;" class="ssy-agree" @click="zhuangtai">同&emsp;&emsp;意</a>
        </div>
        <a class="login_con_loginbtn login_con_regbtn" href="javascript:;" @click="register">
          立即注册
        </a>
      </div>
    </div>
</div>
</template>
<script>
import { getAgreement, sendSMS } from '@/api/login'

export default {
  name: 'Login',
  data () {
    let validateConfirmPassword = (rule, value, callback) => {
      if (value === '') {
        callback(new Error('请输入密码'))
      } else if (value !== this.formData.password) {
        callback(new Error('两次密码输入不一致'))
      } else {
        callback()
      }
    }
    let checkPhone = (rule, value, callback) => {
      if (!value) {
        return callback(new Error('手机号不能为空'))
      } else {
        const reg = /^1[3|4|5|7|8][0-9]\d{8}$/
        if (reg.test(value)) {
          callback()
        } else {
          return callback(new Error('请输入正确的手机号'))
        }
      }
    }
    return {
      formData: {
        account: '',
        tel: '',
        password: '',
        telCode: ''
      },
      about: '',
      isShow: false,
      checked: false,
      codeType: true,
      count: '',
      qyloading: false,
      timer: null,
      rules: {
        account: [{ required: true, message: '请输入账号', trigger: 'blur' }],
        tel: [{ validator: checkPhone, trigger: 'blur' }],
        password: [{ required: true, message: '请输入密码', trigger: 'blur' }],
        telCode: [{ required: true, message: '请输入手机验证码', trigger: 'blur' }],
        confirmpassword: [{ required: true, validator: validateConfirmPassword, trigger: 'blur' }]
      }
    }
  },
  mounted () {
    this.getAgreement()
  },
  methods: {
    getAgreement () {
      getAgreement().then(res => {
        this.about = res.items.content
      })
    },
    zhuangtai () {
      this.checked = true
      this.isShow = false
    },
    register () {
      this.$refs['dataForm'].validate((valid) => {
        if (valid) {
          if (!this.checked) {
            this.$message.error('请先阅读用户注册协议')
            return false
          }
          if (this.qyloading) {
            return
          }
          this.qyloading = true
          this.$store.dispatch('user/register', this.formData).then(() => {
            this.qyloading = false
            this.$router.push({ path: '/Login' })
          }).catch(() => {
            this.qyloading = false
          })
        }
      })
    },
    sendCode () {
      const regs = /^1[3|4|5|7|8][0-9]\d{8}$/
      if (!this.formData.tel || !regs.test(this.formData.tel)) {
        this.$message.error('请输入正确的手机号码')
        return false
      }
      sendSMS({tel: this.formData.tel}).then(res => {
        const TIME_COUNT = 60
        if (!this.timer) {
          this.count = TIME_COUNT
          this.codeType = false
          this.timer = setInterval(() => {
            if (this.count > 0 && this.count <= TIME_COUNT) {
              this.count--
            } else {
              this.codeType = true
              clearInterval(this.timer)
              this.timer = null
            }
          }, 1000)
        }
      })
    },
    // 判断输入密码的类型
    CharMode (iN) {
      if (iN >= 48 && iN <= 57) {
        // 数字
        return 1
      }
      if (iN >= 65 && iN <= 90) {
        // 大写
        return 2
      }
      if (iN >= 97 && iN <= 122) {
        // 小写
        return 4
      } else {
        return 8
      }
    },
    // bitTotal函数
    // 计算密码模式
    bitTotal (num) {
      var modes = 0
      for (var i = 0; i < 4; i++) {
        if (num & 1) modes++
        num >>>= 1
      }
      return modes
    },
    // 返回强度级别
    checkStrong (sPW) {
      if (sPW.length < 6) { return 0 } // 密码太短，不检测级别
      var Modes = 0
      for (var i = 0; i < sPW.length; i++) {
        // 密码模式
        Modes |= this.CharMode(sPW.charCodeAt(i))
      }
      return this.bitTotal(Modes)
    },
    pwStrength (password) {
      var slevel = this.checkStrong(password)
      switch (slevel) {
        case 0:
          this.formData.intensity = '弱'
          break
        case 1:
          this.formData.intensity = '弱'
          break
        case 2:
          this.formData.intensity = '中'
          break
        default:
          this.formData.intensity = '强'
      }
      console.info(this.formData.intensity)
    }
  }
}
</script>
<style scoped>
.regist_xieyibtn{
  font-size: 12px;
}
.m-login-panel{
  overflow: hidden;
  margin-left: 40px;
  padding: 30px 25px;
  background-color: #fff;
  border-radius: 8px;
  position: relative;
  width: 330px;
  min-height: 340px;
  border: 1px solid #eceded;
  box-shadow: 10px 10px 12px 0px rgb(0 55 156 / 15%);
}
  .el-form-item.demo >>> .el-form-item__content{
    margin-left: 0px;
    line-height: 2px;
  }
  .el-form-item >>> .el-form-item__content{
    line-height: 2px;
  }
  .reg_con_pub .login_con_pub{
    height: 40px;
  }
  .login_con_pub_info.login_con_pub_phone{
    height: 40px;
  }
  .el-form-item{
    height: 40px;
  }
</style>



// WEBPACK FOOTER //
// src/view/login/registergr.vue